import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { KiMandantEinstellungen } from '../../../models/ki.model';
import { KiSwitchComponent } from '../../../components/ki/ki-switch/ki-switch.component';

export type KiRasterAenderung = Partial<
  Pick<KiMandantEinstellungen, 'kontingentTokensProMonat' | 'maxAufbewahrungTage' | 'auditInhalte'>
>;

type KiAufbewahrungTage = KiMandantEinstellungen['maxAufbewahrungTage'];

/** Backend-@Min/@Max an KiMandantEinstellungenDTO.kontingentTokensProMonat. */
const KONTINGENT_MIN = 1_000;
const KONTINGENT_MAX = 1_000_000_000;
const KONTINGENT_VORSCHLAG = 5_000_000;
const AUFBEWAHRUNG: readonly KiAufbewahrungTage[] = [30, 60, 90, 180];

export function kontingentGueltig(tokens: number | null): boolean {
  return tokens === null || (tokens >= KONTINGENT_MIN && tokens <= KONTINGENT_MAX);
}

function formatiert(tokens: number): string {
  return tokens.toLocaleString('de-DE');
}

/** Kontingent, Aufbewahrung und Audit-Inhalte (page-ki-einstellungen.jsx:113-139). */
@Component({
  selector: 'app-ki-raster',
  standalone: true,
  imports: [TranslatePipe, KiSwitchComponent],
  templateUrl: './ki-raster.component.html',
  styleUrl: './ki-raster.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiRasterComponent {
  readonly kontingent = input.required<number | null>();
  readonly aufbewahrung = input.required<KiAufbewahrungTage>();
  readonly auditInhalte = input.required<boolean>();
  readonly aenderung = output<KiRasterAenderung>();

  readonly aufbewahrungOptionen = AUFBEWAHRUNG;
  readonly tokensMaxLaenge = formatiert(KONTINGENT_MAX).length;
  readonly begrenzt = computed(() => this.kontingent() !== null);
  readonly kontingentText = computed(() => formatiert(this.kontingent() ?? 0));
  readonly kontingentFehler = computed(() => !kontingentGueltig(this.kontingent()));

  onBegrenzt(begrenzt: boolean): void {
    if (begrenzt === this.begrenzt()) return;
    this.aenderung.emit({ kontingentTokensProMonat: begrenzt ? KONTINGENT_VORSCHLAG : null });
  }

  onTokens(event: Event): void {
    const feld = event.target as HTMLInputElement;
    const tokens = Number(feld.value.replace(/\D/g, '') || '0');
    // Direkt ins Feld, weil ein getippter Buchstabe den Wert nicht ändert und die Bindung ihn sonst stehen ließe.
    feld.value = formatiert(tokens);
    this.aenderung.emit({ kontingentTokensProMonat: tokens });
  }

  onAufbewahrung(event: Event): void {
    const tage = Number((event.target as HTMLSelectElement).value) as KiAufbewahrungTage;
    this.aenderung.emit({ maxAufbewahrungTage: tage });
  }

  onAuditInhalte(an: boolean): void {
    this.aenderung.emit({ auditInhalte: an });
  }
}
